<template>
  <div>
    <v-layout>
      <v-text-field :label="etiket"  @blur="codeControl()" :placeholder="kodmesajı" append-icon="search" @click:append="dialogac()" :tabindex="tabdeger" v-model="val" hide-details=""></v-text-field>
    </v-layout>
    <v-dialog scrollable="" v-model="listedialog" max-width="550px">
      <v-card color="grey lighten-5">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text">{{etiket}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field solo hide-details ref="ara"  autofocus="" v-model="secilenkayit" :label="$t('Please-enter-3-letters')" append-icon="search"></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-layout row="" wrap="">
            <div class="flex md12">
              <v-data-table :headers="headerstip"  :search="secilenkayit" :loading="progress" :items="items" hide-actions class="elevation-1">
                <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <tr @click="kabul(props.item.Ad)" item>
                    <td class="text-xs-left">{{ props.item.Title }}</td>
                    <td class="justify-center layout px-0">
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="listedialog = false">
            {{$t("cancel_button")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
        :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    props: ["value","tabdeger","etiket",'listetip'],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    beforeMount: beforeMount,
    methods: {
      dialogac: dialogac,
      kabul:kabul,
      codeControl:codeControl
    },
    data() {
      return {
        headerstip: [{
            text: this.$t('Description'),
            value: 'Title'
          }
        ],
        kodmesajı:null,
        progress: false,
        items: [],
        aranacakkelime: null,
        secilenkayit: null,
        listedialog: false,

        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {
      // secilenkayit(val) {
      //   val && this.kayitgetir(val)
      // },

    listedialog (val2) {
      if (!val2) return
      requestAnimationFrame(() => {
        this.$refs.ara.focus()
      })
    }

    },
  }
    function beforeMount() {


  }

function codeControl() {

    if (this.val != null && this.val!='') {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

   var params1 = {
       CompanyCode:credentials.SirketKodu,
       Type: this.listetip,
       Name: escape(this.val)
      }

      this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeGet', params1, {
        headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader()}
      }).then((response) => {

        if (response.body.length == 1) {
          this.val = response.body[0].Ad
          this.kodmesajı = null
        } else {
          this.kodmesajı = this.$t('Incorrect-code-entry')
          this.val = null
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-GeneralTypeGet'
          this.snackbar = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable-GeneralTypeGet'
          this.snackbar = true
          this.progress = false
        }
      })
    } else {
      this.kodmesajı = null
    }
  }



  function kabul(m) {
    this.val = m
    this.listedialog = false
  }

  function dialogac() {
   var credentials = JSON.parse(window.localStorage.getItem('credentials'));

     var params1 = {
       CompanyCode:credentials.SirketKodu,
       Type: this.listetip,
      }

      this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeSearch', params1, {
        headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader()}
      }).then((response) => {

      this.items=response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-GeneralTypeSearch'
          this.snackbar = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable-GeneralTypeSearch'
          this.snackbar = true
          this.progress = false
        }
      })


    this.listedialog = true

  }



  // function kayitgetir(y) {

  //   if (y != null) {

  //     if (y.length > 2) {

  //       this.progress = true
  //       var credentials = JSON.parse(window.localStorage.getItem('credentials'));
  //       var params1 = {
  //         CompanyCode: credentials.SirketKodu,
  //         Search: escape(y)
  //       }
  //       this.$http.post(auth.API_URL + 'api/ExpenseCenter/ExpenseCenterSearch', params1, {
  //         headers: {
  //           'Authorization': 'Bearer ' + auth.getAuthHeader()
  //         }
  //       }).then((response) => {
  //         this.items = response.body

  //         this.progress = false
  //       }, (response) => {
  //         if (response.status === 0) {
  //           this.text1 = 'Service Unavailable-Masraf Merkezi'
  //           this.snackbar = true
  //           this.progress = false

  //         } else {
  //           this.text1 = 'Service Unavailable-Masraf Merkezi'
  //           this.snackbar = true
  //           this.progress = false
  //         }
  //       })
  //     } else {
  //       this.items = []
  //       this.progress = false
  //     }

  //   }
  // }
</script>